import { CSSObject } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const FileInputDefaultConfig: MantineThemeComponent = {
	defaultProps: {},
	styles: () => ( {
		input: {
			...( textVariants.footnote as CSSObject ),
			background: 'var(--color-bg-surface)',
			color: 'var(--color-text-primary)',
			borderColor: 'var(--color-outline-default)'
		},
		placeholder: {
			...( textVariants.footnote as CSSObject ),
			color: 'var(--color-text-light) !important'
		},
		icon: {
			color: 'var(--color-text-light)'
		}
	} )
};

export default FileInputDefaultConfig;
